export default __webpack_public_path__ + "static/media/gif_happy-birthday.d7969e57.gif";